import { useSelector } from 'react-redux'

export const useUser = () =>
    useSelector(
        (state) => state.usersReducer.user,
        () => {}
    )
export const useUsers = () =>
    useSelector(
        (state) => state.usersReducer.users,
        () => {}
    )

export const useDancesLeft = () =>
    useSelector(
        (state) =>
            state.usersReducer.user
                ? state.usersReducer.user.max_paralleled_orders -
                  state.usersReducer.user.ordered_dances_counter -
                  state.usersReducer.user.approved_dances_counter
                : 0,
        () => {}
    )
